import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import Vuex from 'vuex'

import config from '@/app-config'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)
Vue.use(VueLocalStorage)

export const store = new Vuex.Store({
  state: {
    loading: false,
    isLoggedIn: !!Vue.localStorage.get('token'),
    isFacebook: Vue.localStorage.get('FB') === 'true',
    isSelectedBot: !!Vue.localStorage.get('selectedBot'),
    selectedBot:
      Vue.localStorage.get('selectedBot') && Vue.localStorage.get('selectedBot') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('selectedBot'))
        : [],
    userid: Vue.localStorage.get('userid'),
    botlist:
      Vue.localStorage.get('botlist') && Vue.localStorage.get('botlist') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('botlist'))
        : [],
    pagelist:
      Vue.localStorage.get('pagelist') && Vue.localStorage.get('pagelist') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('pagelist'))
        : [],
    accessToken: Vue.localStorage.get('token'),
    fbAccessToken: Vue.localStorage.get('fbtoken'),
    openSidebar: true,
    paypalTrackingId: Vue.localStorage.get('paypalTrackingId'),
    welcomeMessage: undefined,
    showModalWelcome: Vue.localStorage.get('showModalWelcome'),
    theme: config.theme,
    chatbot: {
      intentGroup: undefined
    },
    loginChannel: ['facebook', 'account', 'chat2pay'].includes(Vue.localStorage.get('loginChannel'))
      ? Vue.localStorage.get('loginChannel')
      : 'facebook',
    fbScope: Vue.localStorage.get('fbScope'),
    tutoriallist: [],
    alert:
      Vue.localStorage.get('alerts') && Vue.localStorage.get('alerts') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('alerts'))
        : [],
    setting: undefined,
    loadingSetting: true,
    apiList: undefined,
    loadingApiList: true,
    flowList: undefined,
    loadingFlowList: true,
    variableList: undefined,
    loadingVariableList: true,
    selectedFlow: null,
    copyNodes:
      Vue.localStorage.get('copyNodes') && Vue.localStorage.get('copyNodes') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('copyNodes'))
        : [],
    adminList: undefined,
    loadingAdminList: true,

    colorlist: {
      start_node: '#c9f58e',
      node: 'white',
      api: '#a3d3f8',
      flow: '#b0ffde',
      random: '#f8afa3',
      condition: '#ffde92',
      savevariables: '#ecd3ff'
    },
    botOrigins: undefined,
    loadingBotOrigins: true,
    superadmin: ['admin'],
    persistent_menu: undefined,
    loadingPersistentMenu: true
  },
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js